import { render, staticRenderFns } from "./InternalMaterials.vue?vue&type=template&id=415f1a73&scoped=true"
import script from "./InternalMaterials.vue?vue&type=script&lang=js"
export * from "./InternalMaterials.vue?vue&type=script&lang=js"
import style0 from "./InternalMaterials.vue?vue&type=style&index=0&id=415f1a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f1a73",
  null
  
)

export default component.exports